import React from 'react';

import ReactDOM from 'react-dom/client';

import Routing from 'screens/Routing';
import './index.css';
import 'antd/dist/antd.min.css';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

/**
 * Harmless warning, raised by the ag-grid tables when they re-measure, which the development
 * overlay presents as a crash. Intercepted in the capture phase.
 */
const RESIZE_OBSERVER_NOISE = /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

window.addEventListener(
  'error',
  (event) => {
    if (RESIZE_OBSERVER_NOISE.test(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Routing />
  </React.StrictMode>,
);
